import React, { Component } from 'react';

class App extends Component {

  render() {

    const { social, width } = this.props

    return (
      <>
        {social.map( ( elm ) => (
          <a href={elm?.href} target='_blank' className='flex-none flex items-center justify-center'>
            <img src={elm?.image} alt={elm?.name} width={width} height={width} className='h-auto' />
          </a>
        ) )}
      </>
    )
  }
}

export default App;